// extracted by css-extract-rspack-plugin
export default {"toggleButtonMedium":"toggleButtonMedium-_PcASl","toggleButtonLarge":"toggleButtonLarge-ri7HkT"};